export const AGES: Record<string, number> = {
  BC: 19,
  NB: 19,
  NS: 19,
  NT: 19,
  NU: 19,
  YT: 19,
  AB: 18,
  QC: 21,
  MB: 19,
  NL: 19,
  ON: 19,
  PE: 19,
  SK: 19,
  OC: 18,
}